import React from 'react'
import { FaUser, FaEnvelope, FaPhoneAlt, FaPaperPlane } from "react-icons/fa";
import './QueryForm.css';

const QueryForm = () => {
  return (
    <div>
      <div className="queryForm-contact-wrapper">
        {/* Left Panel */}
        <div className="queryForm-contact-info">
          <h3>Have a Question?</h3>
          <p>We’re here to help you plan your perfect trip.</p>
        </div>

        {/* Right Form */}
        <form className="queryForm-contact-form">
          <div className="queryForm-input-row">
            <div className="queryForm-input-box">
              <FaUser className="queryForm-icon" />
              <input type="text" placeholder="Your Name*" required />
            </div>
            <div className="queryForm-input-box">
              <FaEnvelope className="queryForm-icon" />
              <input type="email" placeholder="E-mail*" required />
            </div>
            <div className="queryForm-input-box">
              <FaPhoneAlt className="queryForm-icon" />
              <input type="tel" placeholder="Mobile*" required />
            </div>
            <button type="submit" className="queryForm-submit-btn">
              Submit <FaPaperPlane className="queryForm-btn-icon" />
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default QueryForm
